const IFRAME = 'paycomet_iframe';

export { IFRAME };
